import axios from '../utils/AxiosInstance'
import StorageAnswers from '../utils/StorageAnswers'

export default {
  state: {
    summary: null,
    questionnaire: null,
    token: null
  },
  mutations: {
    SET_SUMMARY (store, summary) {
      store.summary = summary
    },
    SET_QUESTIONNAIRE (store, questionnaire) {
      store.questionnaire = questionnaire
    },
    SET_TOKEN (store, token) {
      store.token = token
    }
  },
  getters: {
    getSummary: (state, getters) => {
      return state.summary
    },
    getQuestionnaire: (state, getters) => {
      return state.questionnaire
    },
    getToken: (state, getters) => {
      return state.token
    }
  },
  actions: {
    /*
    setToken
    */
    setToken ({ commit, dispatch, getters, state }, token) {
      commit('SET_TOKEN', token)
    },
    /*
    setSummary
    */
    setSummary ({ commit, dispatch, getters, state }, params) {
      return axios.get(`guest/questionnaires/${getters.getToken}/summary`).then((response) => {
        commit('SET_SUMMARY', response.data)
        return response.data
      })
    },
    /*
    setQuestionnaire
    */
    setQuestionnaire ({ commit, dispatch, getters, state }, params) {
      return axios.get(`guest/questionnaires/${getters.getToken}`).then((response) => {
        const resetAnswers = StorageAnswers.reset(getters.getToken, response.data)
        commit('SET_QUESTIONNAIRE', resetAnswers)
        return response.data
      })
    },
    /*
    changeQuestionnaire
    */
    changeQuestionnaire ({ commit, dispatch, getters, state }, params) {
      const newQuestionnaire = {...state.questionnaire, ...params}

      StorageAnswers.save(getters.getToken, newQuestionnaire)
      commit('SET_QUESTIONNAIRE', newQuestionnaire)
    },
    /*
    createQuestionnaire
    */
    createQuestionnaire ({commit, dispatch, getters, state}, data) {
      return axios.post(`guest/questionnaires/${getters.getToken}`, data).then((response) => {
        return response.data
      })
    }
  }
}
